import React, { Component } from 'react';
import { Avatar, List, Typography } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import DropdownListWrapper from './DropdownListWrapper';

/* eslint-disable react/prefer-stateless-function */
class NotificationsDropdown extends Component {
  static propTypes = {
    notifications: PropTypes.arrayOf(PropTypes.object),
  };

  static defaultProps = {
    notifications: [],
  };

  renderNotificationItem = item => {
    const avatar = (
      <Avatar
        icon="bell"
        style={{
          backgroundColor: item.title === 'Encounter assigned' ? '#87d068' : '#ff0000',
        }}
      />
    );

    return (
      <List.Item>
        <List.Item.Meta avatar={avatar} title={item.title} description={item.description} />
        <Typography.Text type="secondary" style={{ fontSize: '10px', fontStyle: 'italic' }}>
          {moment(item.createdAt)
            .startOf('seconds')
            .fromNow()}
        </Typography.Text>
      </List.Item>
    );
  };

  render() {
    const { notifications } = this.props;
    return (
      <DropdownListWrapper>
        <List
          itemLayout="horizontal"
          dataSource={notifications}
          renderItem={this.renderNotificationItem}
        />
      </DropdownListWrapper>
    );
  }
}

export default NotificationsDropdown;
